import React, { useRef, useState, useEffect } from 'react';
import { motion, useSpring } from 'framer-motion';

// Pulls its child gently toward the cursor while hovered. Desktop-only.
export default function Magnetic({ children, strength = 0.35 }) {
    const ref = useRef(null);
    const [enabled, setEnabled] = useState(false);
    const x = useSpring(0, { stiffness: 320, damping: 18, mass: 0.5 });
    const y = useSpring(0, { stiffness: 320, damping: 18, mass: 0.5 });

    useEffect(() => {
        const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        setEnabled(fine && !reduce);
    }, []);

    if (!enabled) return <div style={{ display: 'inline-flex' }}>{children}</div>;

    const onMove = (e) => {
        const rect = ref.current.getBoundingClientRect();
        x.set((e.clientX - rect.left - rect.width / 2) * strength);
        y.set((e.clientY - rect.top - rect.height / 2) * strength);
    };

    const onLeave = () => {
        x.set(0);
        y.set(0);
    };

    return (
        <motion.div
            ref={ref}
            style={{ x, y, display: 'inline-flex' }}
            onMouseMove={onMove}
            onMouseLeave={onLeave}
        >
            {children}
        </motion.div>
    );
}
